import request from '@/src/apis/axios';
import { PutBlindApiRequestBody } from '@/src/apis/rest/communityBlind.dtos';
import CommunityCommentDto from '@/src/models/CommunityCommentDto';
import CommunityPostingDto from '@/src/models/CommunityPostingDto';
import { ObjectResponse } from '@/src/types/common';
import { plainToInstance } from 'class-transformer';

const URL = {
  comunityBlindPosting: 'admin/community-postings/{id}/report-type',
  comunityBlindComment: 'admin/community-comments/{id}/report-type',
};

// 커뮤니티 게시글 관리자 블라인드 처리
export const putBlindPostingAPI = async (
  requestBody: Partial<PutBlindApiRequestBody>,
) => {
  const { id, ...rest } = requestBody;

  const { data } = await request<ObjectResponse<CommunityPostingDto>>({
    method: 'put',
    url: URL.comunityBlindPosting.replace('{id}', String(id)),
    requestBody: { ...rest },
  });

  return plainToInstance(CommunityPostingDto, data.row);
};

// 커뮤니티 댓글 관리자 블라인드 처리
export const putBlindCommentAPI = async (
  requestBody: Partial<PutBlindApiRequestBody>,
) => {
  const { id, ...rest } = requestBody;

  const { data } = await request<ObjectResponse<CommunityCommentDto>>({
    method: 'put',
    url: URL.comunityBlindComment.replace('{id}', String(id)),
    requestBody: { ...rest },
  });

  return plainToInstance(CommunityCommentDto, data.row);
};
